import { PAGE_WIDTH_SM } from "../../utilities/constants";
import { useContainerBreakpoint } from "../../utilities/useContainerBreakpoint";
import { PlaybookFilters } from "./PlaybookFilters";

type PlaybookFilterLayoutProps = {
  heading?: React.ReactNode;
  children: React.ReactNode;
  sidebar?: React.ReactNode;
};

export const PlaybookFilterLayout = ({
  heading,
  children,
  sidebar,
}: PlaybookFilterLayoutProps) => {
  const [ref, isWide] = useContainerBreakpoint<HTMLDivElement>(PAGE_WIDTH_SM);

  return (
    <div ref={ref}>
      {isWide ? (
        <div className="flex flex-row items-start gap-x-7xl">
          <div className="flex min-w-0 flex-1 flex-col gap-6">
            {heading}
            {children}
          </div>
          <aside className="flex w-72 shrink-0 flex-col gap-8">
            <PlaybookFilters />
            {sidebar}
          </aside>
        </div>
      ) : (
        <div className="flex flex-col gap-7xl">
          <div className="flex flex-col gap-4">
            {heading}
            <PlaybookFilters />
          </div>
          {children}
          {sidebar}
        </div>
      )}
    </div>
  );
};
